export default "__VITE_ASSET__ZBHI7k9l__"